module.exports = __webpack_public_path__ + "img/error.041cb8f6.svg";